export const BASE_URL = "https://api.depense-sass.msit-demo.fr/";
// export const BASE_URL = `${process.env.REACT_APP_API_ENDPOINT}/`;
export const STATIC_URL = process.env.REACT_APP_API_ENDPOINT;
